import { render, staticRenderFns } from "./ModalRequirements.vue?vue&type=template&id=6be7d869&"
import script from "./ModalRequirements.vue?vue&type=script&lang=js&"
export * from "./ModalRequirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports